(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('AttachmentDialogController', AttachmentDialogController);

    AttachmentDialogController.$inject = ['$timeout','$q','$scope','$stateParams','$uibModalInstance','type','objectId','AttachmentCustomService'];

    function AttachmentDialogController ($timeout, $q, $scope, $stateParams, $uibModalInstance, type, objectId, AttachmentCustomService) {
        var vm = this;

        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save(file) {
            vm.isSsaving = true;
            var promList = [];
            if(file && file.length) {
                angular.forEach(file, function(file) {
                    promList.push(AttachmentCustomService.uploadAttachment(file, type, objectId, file.name));
                });
                if(promList.length > 0) {
                    $q.all(promList).then(function() {
                        onSaveSuccess();
                    }).then(function() {
                        onSaveSuccess();
                    });
                } else {
                    onSaveSuccess();
                }
            } else {
                onSaveSuccess();
            }
        }

        function onSaveSuccess () {
            $uibModalInstance.close();
            vm.isSaving = false;
        }
    }
})();
